var style = {"timePicker":"Time-module_timePicker__6VIOI","dropdownForm":"Time-module_dropdownForm__-6eTb"};

export { style as default };
//# sourceMappingURL=Time.module.scss.js.map
